import Chart from 'chart.js';

class ChartIntegration {
    constructor(dataElement, mainColor, fontFamily) {
        this.dataElement = dataElement;

        if (this.dataElement) {
            this.type = this.getType();
            this.data = this.getData();
            this.min = parseInt(this.dataElement.dataset.min, 10);
            this.max = parseInt(this.dataElement.dataset.max, 10) + 2;
            this.ctx = dataElement.getContext('2d');
            this.chart = null;
            this.mainColor = mainColor;
            this.fontFamily = fontFamily;

            this.createChart();
        }
    }

    getType() {
        return this.dataElement.dataset.type;
    }

    getData() {
        return JSON.parse(this.dataElement.dataset.json);
    }

    createChart() {
        const labels = [];
        const dataSets = [];

        JSON.parse(this.dataElement.dataset.labels).forEach((element) => {
            labels.push(element.title);
        });

        this.data.forEach((element) => {
            const values = [];

            element.data.forEach((innerElement) => {
                values.push(innerElement.value);
            });

            dataSets.push({
                data: values,
                label: element.label,
                borderWidth: 7,
                pointBorderColor: 'rgba(0, 0, 0, 0)',
                pointBackgroundColor: this.mainColor,
                borderColor: this.mainColor,
                backgroundColor: 'rgba(0, 0, 0, 0)',
            });
        });

        this.chart = new Chart(this.ctx, {
            type: this.type,
            data: {
                datasets: dataSets,
                labels,
            },
            options: {
                legend: {
                    display: false,
                },
                gridLines: {
                    lineWidth: 5,
                },
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio: 7,
                scales: {
                    yAxes: [{
                        ticks: {
                            max: this.max + 10,
                            fontSize: 12,
                            stepSize: 10,
                            fontFamily: this.fontFamily,
                            beginAtZero: true,
                        },
                    }],
                    xAxes: [{
                        ticks: {
                            stepSize: 5,
                            fontSize: 12,
                            fontFamily: this.fontFamily,
                        },
                    }],
                },
            },
        });
    }
}

const chart = {
    init(mainColor, fontFamily) {
        this.chartArray = [];
        const charts = document.querySelectorAll('.js-chart');

        charts.forEach((element) => {
            this.chartArray.push(new ChartIntegration(element, mainColor, fontFamily));
        });
    },
};

export default chart;
